import Vue from 'vue'
import Router from 'vue-router'
import MainDashboard from '../dashboards/MainDashboard'
import ManageUsers from '../user/ManageUsers'
import Teams from '../user/Teams'
import Login from '../framework/Login'
import Registration from '../framework/Registration'
import Logout from '../framework/Logout'
import History from "../history/History"
import NondiscriminationTesting from "../shared/NondiscriminationTesting"
import PopNondiscriminationTesting from "../shared/PopNondiscriminationTesting"
import TestPage from "../tests/TestPage"
import MyPlanConnectCarriers from '../shared/MyPlanConnectCarriers'
import ComplianceView from '../compliance/ComplianceView'
import store from '../store'
import changeTracker from "../framework/utils/change-tracker";
import SalesforceExport from '../framework/SalesforceExport'
import Auth from '../framework/Auth'
import AmazonIvr from '../framework/AmazonIvr'
import SettlementInformation from '../finance/SettlementInformation';
import Workflows from '../workflow/Workflows';
import CssTeamStats from '../workflow/CssTeamStats';
import Identity from '../framework/Identity'
import MyEmployers from "../employer/MyEmployers";
import Nacha from '../finance/Nacha.vue';
import NachaDetail from '../finance/NachaDetail.vue';
import HsaPushDetail from '../finance/HsaPushDetail.vue';
import HsaDDFundingReport from '../finance/HsaDDFundingReport.vue';
import HsaIrsReturnFile from '../finance/HsaIrsReturnFile.vue';
import AdminConsole from "../employer/AdminConsole";
import TeamStats from '../workflow/TeamStats';
import Issues from '../shared/PendingIssues'
import auth from '../auth'
import { config } from '../config'
import zendesk from '../framework/utils/zendesk-sso';
import ClaimRejectionCodes from '../framework/ClaimRejectionCodes.vue'
import MfaChallenge from '../framework/MfaChallenge.vue';
import { redirectedAwayFrom } from '../framework/login-redirect'
import metricsService from '../framework/utils/metrics-service'
import RemittanceReportsAllClients from '../finance/RemittanceReportsAllClients.vue';

Vue.use(Router);

function route(path, component, additionalConfig = {}) {
  var props = additionalConfig.props !== undefined && additionalConfig.props !== null ? additionalConfig.props : true;

  delete additionalConfig.props;
  var config = { path, component, props, ...additionalConfig };

  if(component == null) {
    delete config.component;
    delete config.props;
  }

  return config;
}

const router = new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    { path: '/login', name: 'Login', component: Login, meta: { public: true, redirectIfLoggedIn: true } },
    { path: '/identity', name: 'Identity', component: Identity, meta: { public: true, clear_session: true } },
    { path: '/forgot-password', name: 'ForgotPassword', component: Login, meta: { public: true } },
    { path: '/reset-password', name: 'ResetPassword', component: Login, meta: { public: true, redirectIfLoggedIn: true, page: 'resetPassword' }, props: true },
    { path: '/user-registration', name: 'UserRegistration', component: Registration, meta: { public: true }, props: (route) => ({ otp: route.query.otp, username: route.query.username, uuid: route.query.uuid }) },
    { path: '/auth', name: 'auth', component: Auth, meta: { public: true }, props: (route) => ({ token: route.query.token }) },
    { path: '/logout', name: 'Logout', component: Logout, meta: { clear_session: true, public: true } },

    { path: '/', name: 'Dashboard', component: MainDashboard, props: true },
    { path: '/users', name: 'Users', component: ManageUsers, props: true },
    { path: '/users/:userId/history', name: 'UserHistory', meta: { page: 'user '}, component: () => import('../history/UserHistory'), props: true },
    { path: '/teams', name: 'Teams', component: Teams, props: true },
    { path: '/all/history', name: 'History', component: History, props: true },
    { path: '/nondiscrimination', name: 'Nondiscrimination', meta: { page: 'nondiscrimination' }, component: NondiscriminationTesting, props: true },
    { path: '/employer/:employerId/pop-nondiscrimination', name: 'PopNondiscrimination', component: PopNondiscriminationTesting, props: true },
    { path: '/testpage', name: 'TestPage', component: TestPage, props: true },
    { path: '/mpc-carriers', name: 'MyPlanConnectCarriers', meta: { page: 'mpc-carriers'}, component: MyPlanConnectCarriers, props: true },

    route('/participant/:participantId', () => import('../participant/ParticipantView'), {
      children:
      [
        route('', null, { redirect: 'general' }),
        route('general/:section?', () => import('../participant/General')),
        route('accounts/create/:planId', () => import('../accounts/AccountList')),
        route('accounts/:accountId?', () => import('../accounts/AccountList')),
        route('accounts/:accountId/hsa-tax-form-editor', () => import('../accounts/HsaTaxFormEditor')),
        route('history', () => import('../history/ParticipantHistory')),
        route('issues', () => import('../shared/PendingIssues')),
        route('transactions', () => import('../transactions/ParticipantTransactions')),
        route('transactions/:accountTransactionId/history', () => import('../transactions/TransactionHistory')),
        route('transactions/payment/:transactionKey', () => import('../payment/Repayment')),
        route('repayments', () => import('../payment/ParticipantPayment')),
        route('notes', () => import('../note/Notes')),
        route('docrecords', () => import('../docRecord/DocRecord')),
        route('documents', () => import('../participant/ParticipantDocuments')),
        route('hidden', () => import('../participant/Hidden')),
        route('cobra', () => import('../cobra/ParticipantCobra')),
        route('cobra/payments', () => import('../cobra/ParticipantCobraPayments')),
        route('cobra/invoices', () => import('../cobra/ParticipantCobraInvoices')),
        route('cobra/life-event/:electionEventId?', () => import('../cobra/ParticipantCobraLifeEvent')),
        route('cobra/open-enrollment/:electionEventId', () => import('../cobra/ParticipantCobraOpenEnrollment')),
        route('cobra/letters', () => import('../cobra/ParticipantLetters')),
        route('cobra/subsidies', () => import('../cobra/ParticipantSubsidies'))
      ]
    }),

    route('/medical-quote', () => import('../medical-quote/QuoteList')),

    route(`/employer/:employerId`, () => import('../employer/EmployerView'), {
      children:

      [
        route('', null, { redirect: 'general' }),
        route('main', null, { redirect: () => { return store.getters['session/isInvoiceUser'] ? 'reports' : 'general';  } }),
        route('general/:section?', () => import('../employer/EmployerGeneral')),
        route('team', () => import('../employer/EmployerTeam')),
        route('plans', () => import('../plans/Plans')),
        route('banking', () => import('../employer/EmployerFunding')),
        route('history', () => import('../history/EmployerHistory')),
        route('issues', () => import('../shared/PendingIssues')),
        route('participants', () => import('../employer/AllParticipants')),
        route('calendars/:calendarId?', () => import('../employer/EmployerCalendars')),
        route('order/:orderId?', () => import('../employer/EmployerOrder')),
        route('notes', () => import('../note/Notes')),
        route('reports', () => import('../reports/Reports')),
        route('transactions', () => import('../transactions/EmployerTransactions')),
        route('invoices/:invoiceId', () => import('../reports/InvoiceDetails')),
        route('accounts', () => import('../employer/AllAccounts')),

        route('troubleshooting', () => import('../employer/EmployerTroubleshooting')),
        route('documents', () => import('../employer/EmployerDocuments')),
        route('renewal', () => import('../employer/EmployerRenewal')),
        route('plans/documents', () => import('../plans/PlanDocuments')),

        route('cobra', () => import('../cobra/CobraPlans')),
        route('cobra-v2', () => import('../newCobra/NewCobraPlans')),
        route('new-cobra', () => import('../newCobra/NewCobraPlans')),
        route('employer-cobra', null,{redirect: () => { return store.state.employer.usesOurCobra ? 'cobra-v2' : 'cobra' }}),
        route('cobra-v2/open-enrollments', () => import('../cobra/CobraOpenEnrollments')), 
        route('cobra-v2/:planId', () => import('../newCobra/NewCobraPlan')),
        route('cobra/create', () => import('../cobra/CobraPlan')),
        route('cobra/rate-renewal', () => import('../cobra/CobraRateRenewal')),
        route('cobra/:planId', () => import('../cobra/CobraPlan')),
        route('cobra/:planId/rate', () => import('../cobra/CobraRate')),
        route('cobra/:planId/rate/create', () => import('../cobra/CobraRate')),

        route('edi', () => import('../edi/EmployerEdi')),
        route('edi/allfiles', () => import('../edi/EmployerEdiFileList')),
        route('edi/allreports', () => import('../edi/EmployerEdiReportList')),
        route('edi/file/:fileId', () => import('../edi/EmployerEdiFileDetails')),
        route('edi/file/:fileId/data', () => import('../edi/EmployerEdiFileData')),
        route('edi/report/:reportId', () => import('../edi/EmployerEdiReportDetails')),

        route('hsa', () => import('../hsa/EmployerHsa')),
        route('hsa/fundingbatch', () => import('../hsa/FundingBatch')),
      ]
    }),

    route('/partner', () => import('../partner/PartnerView'), {
      children: [
        route('create', () => import('../partner/PartnerCreate')),
        route(':partnerId', () => import('../partner/PartnerGeneral')),
        route(':partnerId/general', () => import('../partner/PartnerGeneral'))
      ]
    }),

    route('/agency', () => import('../agency/AgencyView'), {
      children:
      [
        route('create', () => import('../agency/AgencyCreate')),
        route(':agencyId', () => import('../agency/AgencyGeneral')),
        route(':agencyId/general', () => import('../agency/AgencyGeneral'))
      ]
    }),

    route('/broker', () => import('../broker/BrokerView'), {
      children:
      [
        route('create', () => import('../broker/BrokerCreate')),
        route(':brokerId', () => import('../broker/BrokerGeneral')),
        route(':brokerId/general', () => import('../broker/BrokerGeneral'))
      ]
    }),

    route('/userprofile', () => import('../user/UserProfileView'), {
      children: [
        route('', () => import('../user/UserProfile')),
        route('edit', () => import('../user/EditProfile')),
        route('password', () => import('../user/UserChangePassword')),
        route('signature', () => import('../user/UserEmailSignature'))
      ]
    }),

    route('/jobs', () => import('../Jobs/JobsLayout'), {
      children: [
        route('', () => import('../Jobs/JobList')),
        route('overview', null, { redirect: '/jobs' }),
        route('status/:status', () => import('../Jobs/JobList')),
        route('recurring', () => import('../Jobs/RecurringList'))
      ]
    }),

    { path: '/my-employers', name: 'MyEmployers', component: MyEmployers, meta: { page: 'my-employers'}, props: true },
    { path: '/issues', name: 'Issues', component: Issues, meta : { page: 'issues' }, props: true  },

    { path: '/compliance', name: 'rejectedReversedPayment', meta: { page: 'failedRepayments' }, component: ComplianceView, props: true },
    { path: '/salesforce', name: 'SalesforceExport', component: SalesforceExport },
    { path: '/finance', name: 'SettlementInformation', component: SettlementInformation },
    { path: '/nacha/:payType', name: 'Nacha', component: Nacha },
    { path: '/nacha/nachadetail/:nachaId', name: 'NachaDetail', component: NachaDetail },
    { path: '/nacha/hsapushdetail/:bankTransferId', name: 'HsaPushDetail', component: HsaPushDetail },
    { path: '/hsa-irs-return-file', name: 'HsaIrsReturnFile', component: HsaIrsReturnFile },
    { path: '/hsa-dd-funding-report', name: 'HsaDDFundingReport', component: HsaDDFundingReport },
    { path: '/remittance-reports-all-clients', name: 'RemittanceReportsAllClients', component: RemittanceReportsAllClients },

    { path: '/workflows', name: 'Workflows', component: Workflows },
    { path: '/team', name: 'CssTeamStats', component: CssTeamStats },
    { path: '/team-stats', name: 'TeamStats', component: TeamStats },

    { path: '/admin-console', name: 'AdminConsole', component: AdminConsole },

    { path: '/amazonivr/:ssn', name: 'ivr', component: AmazonIvr},

    { path: '/claim-rejection-codes', name: 'ClaimRejectionCodes', component: ClaimRejectionCodes },

    { path: '/mfa', name: 'MfaChallenge', component: MfaChallenge, props: true, meta: { public: true } }
  ]
});


router.beforeEach(async (to, from, next) => {
  if(redirectedAwayFrom(to))
    return false;

  if(!to.params.employerId && !to.params.participantId) {
    resetBrowserTitle();
  }

  let params = { ...to.params, path: to.path };
  if(to.meta && to.meta.page) {
    params.page = to.meta.page;
  }

  store.commit('route/update', params);

  if(to.path == '/zendesk/sso') {
    zendesk.handleZendeskRoute(to);
    return;
  }

  if(to.matched.some(r => r.meta.clear_session)) {
    resetBrowserTitle();
    auth.logout();
    next();
    return;
  }

  if(to.matched.some(r => r.meta.redirectIfLoggedIn)
    && store.getters['session/loggedIn'])
  {
    next({ path: '/' });
    return;
  }


  if (to.matched.some(r => !r.meta.public)) {
    if (!store.getters['session/loggedIn']) {
      var returnUrl = encodeURIComponent(`${config.romeUi}#${to.fullPath}`);
      var path = to.fullPath  == '/' ? '/login' : `/login?returnUrl=${returnUrl}`;
      next({ path });
      return;
    }
  }

  await changeTracker.confirmNavigation();

  store.dispatch("recent/addToHistory", { route: to });

  metricsService.handleRouteChange(to, from);

  next();
});

router.beforeResolve(async (to, from, next) => {
  let isUserLoggedIn = store.getters['session/loggedIn'];
  if (isUserLoggedIn) {
    await store.dispatch("permissions/load");
  }

  next();
});

function resetBrowserTitle() {
  document.title = "Ameriflex";
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js